import { EventTarget as EventTargetShim } from 'event-target-shim';

// eslint-disable-next-line no-new
try { new EventTarget(); } catch { window.EventTarget = EventTargetShim; }
